<template>
  <div class="d-flex justify-content-center align-items-center" :style="`height: ${height}px`">
    <b-spinner type="grow" label="Spinning" variant="primary"/>
  </div>
</template>

<script>
export default {
  name: "ChartSkeleton",
  props: {
    height: {
      type: Number,
      default: 400
    },
  }
}
</script>

<style scoped>
.reverse {
  transform: scale(1, -1);
}
</style>